/**
 * @ngdoc service
 * @name manager.api.LinkedAccount
 *
 */

import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createAutoSignInUrl: {
        method: 'POST',
        url: `${BASE_PATH_API}/linkedaccount/autosigninurl`,
        transformResponse: function transformResponse(response, headers) {
            return {
                location: headers.get('Location')
            };
        }
    },
    getLinkedAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/linkedaccount/:accountStateId`
    }
};
export function LinkedAccountApi() {
    return createActions(actions);
}
